import { render, staticRenderFns } from "./select-order-type .vue?vue&type=template&id=1044d3d9"
import script from "./select-order-type .vue?vue&type=script&lang=ts"
export * from "./select-order-type .vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports